import { IEditModifierState } from './editModifierContext';
import { TEditModifierAction, EditModifierActionTypes } from './editModifierActions';

export const editModifierReducer = (state: IEditModifierState, action: TEditModifierAction): IEditModifierState => {
	switch (action.type) {
		case EditModifierActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
			};
		case EditModifierActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditModifierActionTypes.SET_ALL_DATA:
			return {
				...state,
				modifierId: action.payload.modifierId,
				filePath: action.payload.filePath,
				preSignedUrl: action.payload.preSignedUrl,
				selectedCustomer: action.payload.selectedCustomer,
				restaurantsForPrice: action.payload.restaurantsForPrice,
				totalPrices: action.payload.totalPrices,
				IDsIsForceDisabledRestaurant: action.payload.IDsIsForceDisabledRestaurant,
				selectedModifierGroups: action.payload.selectedModifierGroups,
				name: action.payload.name,
				articleNumber: action.payload.articleNumber,
				description: action.payload.description,
				externalId: action.payload.externalId,
				isDisabledInRestaurants: action.payload.isDisabledInRestaurants,
				isRestrictedInRestaurants: action.payload.isRestrictedInRestaurants,
				isPreselectedInRestaurants: action.payload.isPreselectedInRestaurants,
				quantityRegulationRestaurants: action.payload.quantityRegulationRestaurants,
				quantityMaxLimit: action.payload.quantityMaxLimit,
				translations: action.payload.translations,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditModifierActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditModifierActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case EditModifierActionTypes.DELETE_PHOTO:
			return {
				...state,
				filePath: null,
				fileId: null,
			};
		case EditModifierActionTypes.SET_CUSTOMER:
			return {
				...state,
				selectedCustomer: action.payload.customer,
				fetchedRestaurants: [],
				restaurantsForPrice: [],
				totalPrices: [],
				fetchedModifierGroups: [],
				selectedModifierGroups: [],
				isDisabledInRestaurants: [],
				isRestrictedInRestaurants: [],
				isPreselectedInRestaurants: [],
				quantityRegulationRestaurants: [],
				quantityMaxLimit: null,
				defaultCustomerLanguage: null,
			};
		case EditModifierActionTypes.SET_FETCHED_MODIFIER_GROUPS:
			return {
				...state,
				fetchedModifierGroups: action.payload.modifierGroups,
			};
		case EditModifierActionTypes.SET_MODIFIER_GROUPS:
			return {
				...state,
				selectedModifierGroups: action.payload.modifierGroups,
			};
		case EditModifierActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case EditModifierActionTypes.CHANGE_EXTERNAL_ID:
			return {
				...state,
				externalId: action.payload.externalId,
			};
		case EditModifierActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case EditModifierActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case EditModifierActionTypes.SET_RESTAURANTS_FOR_PRICE:
			return {
				...state,
				restaurantsForPrice: action.payload.restaurants,
			};
		case EditModifierActionTypes.CHANGE_PRICE:
			return {
				...state,
				price: action.payload.price,
			};
		case EditModifierActionTypes.ADD_PRICE:
			return {
				...state,
				totalPrices: [...state.totalPrices, ...action.payload.prices],
				price: '',
			};
		case EditModifierActionTypes.REMOVE_PRICE:
			return {
				...state,
				totalPrices: action.payload.updatedTotalPrices,
				restaurantsForPrice: action.payload.updatedRestaurantsForPrices,
				isDisabledInRestaurants: action.payload.updatedIsDisabledInRestaurants,
				isRestrictedInRestaurants: action.payload.updatedIsRestrictedInRestaurants,
				isPreselectedInRestaurants: action.payload.updatedIsPreselectedInRestaurants,
				quantityRegulationRestaurants: action.payload.updatedQuantityRegulationRestaurants,
				quantityMaxLimit: !action.payload.updatedQuantityRegulationRestaurants.length
					? null
					: state.quantityMaxLimit,
				IDsIsForceDisabledRestaurant: action.payload.updatedIDsIsForceDisabledRestaurant,
			};
		case EditModifierActionTypes.SET_IDS_IS_FORCE_DISABLED_RESTAURANT:
			return {
				...state,
				IDsIsForceDisabledRestaurant: action.payload.IDsIsForceDisabledRestaurant,
			};
		case EditModifierActionTypes.SET_IS_DISABLED_IN_RESTAURANTS:
			return {
				...state,
				isDisabledInRestaurants: action.payload.disabledInRestaurants,
			};
		case EditModifierActionTypes.SET_IS_RESTRICTED_IN_RESTAURANTS:
			return {
				...state,
				isRestrictedInRestaurants: action.payload.restrictedInRestaurants,
			};
		case EditModifierActionTypes.SET_IS_PRESELECTED_IN_RESTAURANTS:
			return {
				...state,
				isPreselectedInRestaurants: action.payload.preselectedInRestaurants,
			};
		case EditModifierActionTypes.SET_QUANTITY_REGULATION_RESTAURANTS:
			return {
				...state,
				quantityRegulationRestaurants: action.payload.quantityRegulationRestaurants,
				quantityMaxLimit: !action.payload.quantityRegulationRestaurants.length ? null : state.quantityMaxLimit,
			};
		case EditModifierActionTypes.CHANGE_QUANTITY_MAX_LIMIT:
			return {
				...state,
				quantityMaxLimit: action.payload.quantityMaxLimit,
			};
		case EditModifierActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE:
			return {
				...state,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case EditModifierActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case EditModifierActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case EditModifierActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case EditModifierActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditModifierActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditModifierActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditModifierActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case EditModifierActionTypes.RESET_FIELDS:
			return {
				...state,
				filePath: null,
				fileId: null,
				selectedCustomer: null,
				fetchedModifierGroups: [],
				selectedModifierGroups: [],
				name: '',
				externalId: '',
				description: '',
				fetchedRestaurants: [],
				restaurantsForPrice: [],
				price: '',
				totalPrices: [],
				IDsIsForceDisabledRestaurant: [],
				isDisabledInRestaurants: [],
				isRestrictedInRestaurants: [],
				isPreselectedInRestaurants: [],
				quantityRegulationRestaurants: [],
				quantityMaxLimit: null,
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				activationSchedule: null,
				deactivationSchedule: null,
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
